module.exports = __webpack_public_path__ + "3f8977db272cc844095be97e8444be02.svg";